import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";

import { Button } from "@/components/ui/button";

/** 403 page shown when a route's permission guard denies access. */
export function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <ShieldAlert className="h-12 w-12 text-destructive" />
      <h1 className="text-2xl font-semibold">403</h1>
      <p className="text-sm text-muted-foreground">{t("common.unauthorized")}</p>
      <Button asChild variant="outline">
        <Link to="/">{t("common.back")}</Link>
      </Button>
    </div>
  );
}
